import React, { useState } from "react";
import "./Accountsignup.scss";
import FormInputs from "../FormInputs/FormInputs";
import { useNavigate } from "react-router-dom";
import Button from "../Button";
import { emailRegex, mobileRegex, usernameRegex } from "../../services/Regex";

const initialValue = {
  userName: "",
  email: "",
  mobileNumber: "",
};

const Accountsignup = ({
  onNext,
  onBack,
  isBackDisabled,
  registerData,
  setRegisterData,
}) => {
  const [errors, setErrors] = useState(initialValue);
  const navigate = useNavigate();
  const handleNav = () => {
    navigate("/");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRegisterData({
      ...registerData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const validateFields = () => {
    let errObj = { ...initialValue };
    if (!registerData.userName || !registerData.userName.trim()) {
      errObj.userName = "Username is required";
    } else if (!usernameRegex.test(registerData.userName)) {
      errObj.userName = "Username can only contain alphanumeric characters";
    } else {
      errObj.userName = "";
    }

    if (!registerData.email) {
      errObj.email = "Email is required";
    } else if (!emailRegex.test(registerData.email)) {
      errObj.email = "Invalid email format";
    } else {
      errObj.email = "";
    }

    if (!registerData.mobileNumber) {
      errObj.mobileNumber = "Mobile Number is required";
    } else if (!mobileRegex.test(registerData.mobileNumber)) {
      errObj.mobileNumber = "Invalid mobile number format";
    } else {
      errObj.mobileNumber = "";
    }

    setErrors(errObj);
    const data = Object.values(errObj).every((x) => x === "" || x === null);
    return data;
  };

  const handleCheckError = () => {
    if (validateFields()) onNext();
  };

  return (
    <div className="account">
      <div className="account_box">
        <div className="account_box_header">
          <div className="account_box_header_heading">
            <h1>Create Account</h1>
          </div>
          <div className="account_box_header_text" onClick={handleNav}>
            <p>
              Already have an account? <span>Login</span>
            </p>
          </div>
          <div className="account_box_header_content">
            <div className="account_box_header_content_inputs">
              <FormInputs
                title="Username"
                placeholder="Enter your username"
                name="userName"
                value={registerData?.userName}
                onChange={handleChange}
                error={errors?.userName}
              />
            </div>
            <div className="account_box_header_content_inputs">
              <FormInputs
                title="Email"
                placeholder="Enter your email"
                name="email"
                value={registerData?.email}
                onChange={handleChange}
                error={errors?.email}
              />
            </div>
            <div className="account_box_header_content_inputs">
              <FormInputs
                title="Mobile phone"
                placeholder="Enter your mobile phone"
                name="mobileNumber"
                value={registerData?.mobileNumber}
                onChange={handleChange}
                error={errors?.mobileNumber}
                maxLength={10}
                minLength={10}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="buttons">
        <Button
          style={{ background: "#F0F6FC", color: "gray" }}
          disabled={isBackDisabled}
          onClick={onBack}
        >
          &lt; Back
        </Button>
        <Button onClick={handleCheckError}>Next</Button>
      </div>
    </div>
  );
};

export default Accountsignup;
